import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subscriber, Subscription } from 'rxjs';
import { ApiService } from '../base/api.service';
import { ApiEndpointsService } from '../base/api-endpoints.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { TaskService } from '../tasks/task.service';
import { Task } from '../../interfaces/task/task';

@Injectable()

export class OverviewService {

  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
              private taskService: TaskService,
  ) {
  }

  tiles(): Observable<any> {
    return new Observable<any>((o: Subscriber<any>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('overview.tiles'))
        .subscribe((response: ServerResponse | any): void => {
          if (typeof response !== 'undefined') {
            o.next(response);
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  tasks(id: number, formData: any): Observable<Task[] | boolean> {
    return new Observable<Task[] | boolean>((o: Subscriber<Task[] | boolean>) => {
      const subscription: Subscription = this.api.get(this.apiEndpoints.get('overview.tile.tasks', {':tile_id': id}), formData)
        .subscribe((response: ServerResponse): void => {
          if (typeof response.data !== 'undefined') {
            o.next(<Task[]>response.data);

            if (typeof response.data !== 'undefined') {
              this.taskService.listOfTaskIds = response.data.map((d: Task): number => d.id);
              this.taskService.listOfTaskIdsUpdated.next();
            }
          } else {
            o.next(false);
          }
        }, (): void => {
          o.next(false);
        });

      return (): void => {
        subscription.unsubscribe();
      };
    });
  }

  map(formData: any): Observable<ServerResponse> {
    return this.api.post(this.apiEndpoints.get('overview'), formData);
  }
}
